<template>
  <div class="min-h-screen">
    <SegmentHero
      title="Termos de Uso"
      description="Condições de uso do site, dos nossos sistemas por assinatura e da compra de Certificado Digital."
      title-class="text-white drop-shadow-md"
      primary-label=""
      primary-href=""
      secondary-label=""
      secondary-href=""
      disclaimer=""
      :background-image="heroBg"
      background-class="bg-center bg-cover bg-slate-900"
      overlay-variant="left"
    />

    <!-- Conteúdo -->
    <div class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto">
          <p class="text-sm text-gray-400 mb-6">
            Última atualização: Julho de 2026 · Kali Sistemas · CNPJ 55.252.075/0001-51
          </p>

          <section class="space-y-12">
            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                1. Aceitação dos Termos
              </h2>
              <p class="mt-3 text-gray-600">
                Estes Termos de Uso regem o acesso e uso do site institucional
                da Kali Sistemas (CNPJ 55.252.075/0001-51), incluindo a
                navegação pelo conteúdo, o agendamento de demonstrações, o
                atendimento via chat/WhatsApp e a compra direta de Certificado
                Digital. Ao usar este site, você concorda com estes termos. Se
                não concordar, não deve utilizá-lo.
              </p>
              <p class="mt-3 text-gray-600">
                A contratação dos nossos sistemas de gestão (Kali Gestão, Kali
                Agro, Kali Food, Kali Clínica, Kali Salão, Kali Shop, Kali Pet
                e Kali Studio) é feita por meio de proposta comercial e
                contrato de prestação de serviços específico, assinado
                digitalmente entre a Kali Sistemas e o cliente — este documento
                não substitui aquele contrato, mas se aplica ao uso deste site
                e à compra de Certificado Digital feita diretamente por aqui.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                2. Nossos Serviços
              </h2>
              <p class="mt-3 text-gray-600">
                A Kali Sistemas oferece sistemas de gestão (ERP/CRM) por
                assinatura mensal, organizados em pacotes por segmento de
                mercado, com módulos inclusos e módulos adicionais
                contratáveis conforme a necessidade do cliente. As condições
                comerciais de cada assinatura — valor, forma de pagamento,
                prazo de implantação, SLA de suporte e regras de cancelamento
                — constam no contrato de prestação de serviços assinado no
                momento da contratação, disponível para consulta e assinatura
                no Portal do Cliente.
              </p>
              <p class="mt-3 text-gray-600">
                Além dos sistemas por assinatura, vendemos diretamente por este
                site o Certificado Digital (e-CPF e e-CNPJ, padrão A1,
                ICP-Brasil), cujas condições específicas de compra estão na
                seção 4 abaixo.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                3. Cadastro e Conta (Portal do Cliente)
              </h2>
              <p class="mt-3 text-gray-600">
                Ao criar uma conta no Portal do Cliente — seja como assinante
                de um dos nossos sistemas, seja para acompanhar a compra de um
                Certificado Digital — você é responsável por manter seus dados
                de acesso em sigilo e por todas as atividades realizadas com
                seu login e senha. Avise-nos imediatamente pelo e-mail
                <a
                  href="mailto:suporte@kalisistemas.com.br"
                  class="text-[#006086] font-semibold hover:underline"
                  >suporte@kalisistemas.com.br</a
                >
                em caso de uso não autorizado da sua conta.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                4. Compra de Certificado Digital
              </h2>
              <p class="mt-3 text-gray-600">
                A compra de Certificado Digital (e-CPF ou e-CNPJ A1) por este
                site segue as seguintes condições:
              </p>
              <ul class="mt-3 list-disc pl-5 text-gray-600 space-y-2">
                <li>
                  O preço exibido no momento da finalização da compra é o
                  valor válido para o pedido, incluindo eventuais descontos
                  automáticos ou cupons aplicados.
                </li>
                <li>
                  O pagamento é feito via Pix (compensação imediata) ou
                  boleto bancário (compensação em até 3 dias úteis), conforme
                  escolhido no checkout.
                </li>
                <li>
                  Após a confirmação do pagamento, você deve enviar os
                  documentos solicitados pelo
                  <a
                    :href="portalUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-[#006086] font-semibold hover:underline"
                    >Portal do Cliente</a
                  >
                  para que a emissão do certificado seja realizada.
                </li>
                <li>
                  A nota fiscal é emitida com base nos dados (nome/razão
                  social, CPF/CNPJ e endereço) informados por você no
                  checkout — confira-os antes de finalizar o pedido.
                </li>
                <li>
                  O certificado emitido tem validade de 12 meses a partir da
                  data de emissão.
                </li>
              </ul>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                5. Direito de Arrependimento e Cancelamento
              </h2>
              <p class="mt-3 text-gray-600">
                Por se tratar de uma compra feita fora de estabelecimento
                físico, você tem o direito de se arrepender da compra do
                Certificado Digital em até 7 (sete) dias corridos, contados da
                confirmação do pedido, com direito a reembolso integral,
                conforme o art. 49 do Código de Defesa do Consumidor. Esse
                direito deixa de se aplicar caso o certificado já tenha sido
                efetivamente emitido a seu pedido dentro desse prazo — já que,
                nesse caso, o serviço já foi integralmente prestado. Para
                solicitar o cancelamento, entre em contato pelo e-mail
                <a
                  href="mailto:suporte@kalisistemas.com.br"
                  class="text-[#006086] font-semibold hover:underline"
                  >suporte@kalisistemas.com.br</a
                >
                informando o código do pedido.
              </p>
              <p class="mt-3 text-gray-600">
                O cancelamento de assinaturas dos nossos sistemas de gestão
                segue as regras específicas definidas no respectivo contrato
                de prestação de serviços.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                6. Uso Aceitável do Site
              </h2>
              <p class="mt-3 text-gray-600">
                Ao usar este site, você concorda em não:
              </p>
              <ul class="mt-3 list-disc pl-5 text-gray-600 space-y-2">
                <li>
                  Fornecer informações falsas nos formulários de contato,
                  agendamento de demonstração ou compra;
                </li>
                <li>
                  Tentar acessar áreas restritas, contornar mecanismos de
                  segurança ou interferir no funcionamento do site;
                </li>
                <li>
                  Copiar, reproduzir ou redistribuir o conteúdo do site para
                  fins comerciais sem autorização prévia por escrito;
                </li>
                <li>
                  Usar robôs, scraping ou qualquer meio automatizado para
                  extrair dados do site fora do uso normal de navegação.
                </li>
              </ul>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                7. Propriedade Intelectual
              </h2>
              <p class="mt-3 text-gray-600">
                A marca "Kali Sistemas" e as marcas de cada solução (Kali
                Gestão, Kali Agro, Kali Food, Kali Clínica, Kali Salão, Kali
                Shop, Kali Pet, Kali Studio), assim como os textos, layout,
                logotipos e demais materiais deste site, são de propriedade da
                Kali Sistemas ou usados sob licença, e protegidos pela
                legislação de direitos autorais e de propriedade industrial
                aplicável. O software licenciado aos clientes assinantes é
                regido pelas condições de uso e licenciamento descritas no
                respectivo contrato de prestação de serviços.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                8. Precisão das Informações e Disponibilidade
              </h2>
              <p class="mt-3 text-gray-600">
                Empregamos esforços razoáveis para manter as informações deste
                site atualizadas, incluindo preços, promoções e
                funcionalidades descritas. Preços de Certificado Digital e
                promoções podem ser alterados a qualquer momento, valendo o
                valor exibido no momento da confirmação do pedido. Podemos
                também atualizar o conteúdo deste site sem aviso prévio.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                9. Limitação de Responsabilidade
              </h2>
              <p class="mt-3 text-gray-600">
                Este site e seu conteúdo são fornecidos "como estão". Não
                garantimos que o site estará livre de interrupções ou erros.
                Na máxima extensão permitida em lei, não seremos responsáveis
                por danos indiretos decorrentes do uso ou da impossibilidade
                de uso deste site. Esta limitação não afasta os direitos
                garantidos pelo Código de Defesa do Consumidor nas relações de
                consumo mantidas conosco, nem as obrigações assumidas no
                contrato de prestação de serviços firmado com clientes
                assinantes.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                10. Links de Terceiros
              </h2>
              <p class="mt-3 text-gray-600">
                Nosso site pode conter links para sites de terceiros
                (parceiros, redes sociais, WhatsApp, provedores de pagamento).
                Não nos responsabilizamos pelo conteúdo ou pelas práticas
                desses sites. O acesso a eles é por sua conta e risco.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                11. Privacidade e Proteção de Dados
              </h2>
              <p class="mt-3 text-gray-600">
                O tratamento dos seus dados pessoais neste site é descrito em
                detalhes na nossa
                <RouterLink
                  to="/politica-de-privacidade"
                  class="text-[#006086] font-semibold hover:underline"
                  >Política de Privacidade</RouterLink
                >
                e na nossa
                <RouterLink
                  to="/politica-de-cookies"
                  class="text-[#006086] font-semibold hover:underline"
                  >Política de Cookies</RouterLink
                >, que fazem parte integrante destes Termos de Uso.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                12. Alterações destes Termos
              </h2>
              <p class="mt-3 text-gray-600">
                Podemos revisar estes Termos de Uso a qualquer momento para
                refletir mudanças legais, operacionais ou nos serviços
                oferecidos. A versão vigente é sempre a publicada nesta
                página, com a data de atualização indicada no topo.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                13. Lei Aplicável e Foro
              </h2>
              <p class="mt-3 text-gray-600">
                Estes Termos de Uso são regidos pelas leis brasileiras. Fica
                eleito o foro do domicílio do consumidor para dirimir eventuais
                controvérsias decorrentes destes termos, conforme o Código de
                Defesa do Consumidor.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                14. Contato
              </h2>
              <p class="mt-3 text-gray-600">
                Dúvidas sobre estes Termos de Uso podem ser enviadas para
                <a
                  href="mailto:suporte@kalisistemas.com.br"
                  class="text-[#006086] font-semibold hover:underline"
                  >suporte@kalisistemas.com.br</a
                >.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>

    <CTA />
  </div>
</template>

<script setup>
import CTA from "@/components/home/CTA.vue";
import SegmentHero from "@/components/ui/SegmentHero.vue";
import heroBg from "@/assets/privacy-bg.webp";
import { useSeo } from "@/composables/useSeo";

const portalUrl =
  import.meta.env?.VITE_PORTAL_URL || "https://portal.kalisistemas.com.br";

useSeo({
  title: "Termos de Uso | Kali Sistemas",
  description:
    "Condições de uso do site, dos nossos sistemas por assinatura e da compra de Certificado Digital.",
  image: heroBg,
});
</script>
